import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Ordine} from '../../_models/Ordine';
import {LocalService} from '../../_services/local.service';
import {Subscription} from 'rxjs';
import {MessageConfirm} from '../../_helpers/message-confirm.service';
import {OrganizzazioniService} from '../../_services/organizzazioni.service';
import {SaveMessage} from '../../_helpers/save-message';
import {OrdiniUpdateSendComponent} from '../ordini-update-send/ordini-update-send.component';
import {ModalController} from '@ionic/angular';
import {OrdiniShowColumns} from '../../_models/OrdiniShowColumns';
import {StatoEnum} from '../../_models/generated/stato-enum'

@Component({
  selector: 'app-ordine-local-item',
  templateUrl: './ordine-local-item.component.html',
  styleUrls: ['./ordine-local-item.component.scss'],
  standalone: false
})
export class OrdineLocalItemComponent implements OnInit, OnDestroy {
  @Input() ordine: Ordine;
  @Input() updateEnable: boolean;
  @Output() ordineSended = new EventEmitter<Ordine>();
  isDeletePending = false;
  showColumns: OrdiniShowColumns;
  dataOggi = new Date().toISOString();
  subscription: Subscription;
  today = new Date().toISOString();
  protected readonly StatoEnum = StatoEnum

  constructor(
    private organizzazioniService: OrganizzazioniService,
    private messageConfirm: MessageConfirm,
    private saveMessage: SaveMessage,
    private modalCtrl: ModalController,
    private localService: LocalService) {}

  ngOnInit() {
    this.subscription = this.localService.lastOrdineUpdated.subscribe((_ordine: Ordine) => {
      if (_ordine == null) {
        return false;
      }
      if (!this.ordine.isLoading &&
        _ordine.numRegistrazione > 0 &&
        this.ordine.idDocumento === _ordine.idDocumento &&
        this.ordine.idRiga === _ordine.idRiga &&
        this.ordine.idRigaLavorazione === _ordine.idRigaLavorazione) {
        this.ordine = _ordine;
      }
    });
    this.showColumns = this.localService.showColumns.value;
    this.subscription.add(this.localService.showColumns.subscribe((_showColumns: OrdiniShowColumns) => this.showColumns = _showColumns));
  }

  deleteOrdine = (ordine: Ordine) => {
    if (this.isDeletePending || ordine.onQueue) {
      return;
    }
    this.messageConfirm
      .presentAlert(`Confermi di eliminare l'ordine ${ordine.numRegistrazione} (${ordine.idDocumento}.${ordine.idRiga}.${ordine.idRigaLavorazione}) e tutti gli eventi collegati?`, () => {
        this.isDeletePending = true;
        this.localService.deleteOrdineAsync(this.organizzazioniService.organizzazioneId, ordine.idDocumento,
          ordine.idRiga, ordine.idRigaLavorazione)
          .then(() => {
            this.ordine.onQueue = true;
            this.localService.markOrdineDeletePending(this.ordine);
            this.saveMessage.messageInfo("Richiesta di eliminazione dell'ordine inviata con successo.");
          })
          .catch(() => {
            this.isDeletePending = false;
            this.ordine.onQueue = false;
            this.localService.clearOrdineDeletePending(this.ordine);
            this.saveMessage.messageError("Ci sono problemi con l'eliminazione dell'ordine.");
          });
      });
  };

  selectOrdine = (ordine: Ordine) => {
    if (this.isDeletePending || this.ordine.onQueue) {
      return;
    }
    if (this.updateEnable && !ordine.isLoading) {
      this.openOrdineWithTempo(ordine);
    } else {
      this.ordineSended.emit(ordine);
    }
  };

  openOrdineWithTempo = (ordine: Ordine) => {
    ordine.isLoading = true;
    this.localService.getOrdiniTempoAsync(ordine.organizzazioneId, ordine.idDocumento, ordine.idRiga, ordine.idRigaLavorazione)
      .then(async (_ordine: Ordine) => await this.openModal(_ordine))
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dell'ordine."))
      .finally(() => ordine.isLoading = false);
  };

  async openModal(element) {
    const modal = await this.modalCtrl.create({
      component: OrdiniUpdateSendComponent,
      backdropDismiss: false,
      componentProps: {ordine: element, data: this.dataOggi},
      cssClass: 'custom-modal'
    });
    await modal.present();
    const {role} = await modal.onWillDismiss();
    if (role === 'save' || role === 'send') {
      //this.localService.handleRefresh.next(1);
      //this.ordine.onQueue = true;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
